<template>
  <div class="review-bankcard">
     <div class="blank_space">
        <div class="icon">
            <i class="icon-hetong iconfont"></i>
        </div>
        <div>
            <h3>审核资料</h3>
            <span>请仔细核对以下信息，确认无误后进行审核</span>
        </div>
        <div class="btn">
            <el-button  size="small">返回上一页</el-button>
        </div>
     </div>
     <!--门店详情-->
     <div class="store-details">
        <div class="title" >
            <i class="iconfont icon-ruzhugongsi"></i>
            门店详情
            <div class="btn" @click="goStoreDetail(infoData.store_type,infoData.store_id)"><el-button  size="small" type="primary" >查看详情</el-button></div>
        </div>
        <!-- <div class="title">
            <i class="iconfont icon-kehu"></i>
            用户详情
            <div class="btn" @click="checkDetail(infoData)"><el-button  size="small" type="primary" >查看详情</el-button></div>
        </div> -->
     </div>
     <!--审核信息-->
     <div class="review-info">
        <div class="title">
            <i class="iconfont icon-ruzhugongsi"></i>
            审核信息
        </div>
            <div class="d-center-between flex-wrap pt-3 pb-3">
                <div class="w-40 mb-4 d-start-start text-left">
                    <left-text leftText="门店类型"/>
                    <label>
                        <span class="mr-3">{{infoData.store_type| formatVar('StoreType')}} </span>
                    </label>
                </div>
                <div class="w-40 mb-4 d-start-start text-left">
                    <left-text leftText="所属类型"/>
                    <label>
                        <span class="mr-3">{{infoData.type==1?'企业':'个人'}} </span>
                    </label>
                </div>
                <div class="w-40 mb-4 d-center-start">
                    <left-text :leftText="infoData.type==1?'企业名称':'个人名称'"/>
                    <label>
                        <span class="mr-3">{{infoData.truename}} </span>
                    </label>
                </div>
                <div class="w-40 mb-4 d-start-start text-left"> 
                    <left-text leftText="开户银行"/>
                    <label>
                        <span class="mr-3">{{infoData.bank_name}} </span>
                    </label>
                </div>
                <div class="w-40 mb-4 d-center-start">
                    <left-text leftText="银行卡号"/>
                    <label>
                        <span class="mr-3">{{infoData.bank_card}} </span>
                    </label>
                </div>
                <div class="mb-4 d-start-start text-left w-100">
                    <left-text leftText="开户支行名称"/>
                    {{infoData.city_name}}省{{infoData.province_name}}市{{infoData.district_name}}{{infoData.branch}}
                    <!-- <i class="el-icon-location location" v-if="storeInfo.type==3&&StoreBasicInfo.longitude" @click="mapclock(StoreBasicInfo.longitude,StoreBasicInfo.latitude,StoreBasicInfo.title)"></i> -->
                </div>
                <div class="mb-4 d-start-start text-left w-40">
                    <left-text leftText="备注"/>
                    {{infoData.remark}}
                </div>
                <!-- <div class="mb-4 d-start-start text-left w-40">
                    <left-text leftText="认证状态"/>
                    <span :class="[infoData.verify===1?'text-success':'text-danger']">{{infoData.verify | formatVar('verifyType')}}</span>
                </div> -->
                <div class="mb-4 d-start-start text-left w-40" v-if="infoData.type==2">
                    <left-text leftText="企业授权证明"/>
                    <el-image 
                        style="width: 100px; height: 100px"
                        :src="ImgPreUrl+infoData.pic" 
                        >
                    </el-image>
                </div>
            </div>
        </div>
        <!--操作说明-->
        <div class="review-info">
            <div class="title">
                <i class="iconfont icon-ruzhugongsi"></i>
                审核操作
            </div>
            <div class="bottom">
                <el-button type="success" @click="passStore" class="mr-2">通过审核</el-button>
                <el-button type="danger"  @click="refuseVerify = true">审核拒绝</el-button>
            </div>
        </div>
        <!--审核拒绝弹窗-->
        <el-dialog title="选择拒绝原因" :visible.sync="refuseVerify" center width="670px" top="17%">
            <el-radio-group  v-model="refuseValue">
                <el-radio :label="item"  v-for="(item,index) in refuseArr" :key="index" class="mb-2 ml-0 mr-4">{{item}}</el-radio>
                <p class="d-center-start" v-if="refuseValue==='其他'">其他：
                    <el-input v-model="verifyRemark" class="w-100 mt-2"  placeholder="请输入拒绝原因"/>
                </p>
            </el-radio-group>
            <div slot="footer">
                <el-button @click="refuseVerify = false">取 消</el-button>
                <el-button type="primary" @click="verifyControl">确 定</el-button>
            </div>
        </el-dialog>
        <!--用户详情弹窗-->
        <el-dialog title="用户详情" :visible.sync="showDetail" center :show-close="false">
            <div class="d-flex flex-wrap">
            <div class="d-center-start w-50 mb-3" v-for="item in showDetailArr" :key="item.name">
                <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
            </div>
            <div class="d-center-start w-50 mb-3">
                <left-text leftText="账号密码"/>
                <span v-show="showPassword" class="mr-2">{{currentItem.password}}</span>
                <i class="iconfont text-link" @click="showPassword = !showPassword"
                :class="[showPassword ? 'icon-yanjing-zheng' : 'icon-yanjing-bi']"></i>
            </div>
            </div>
            <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
        </el-dialog>
  </div>
</template>

<script>
  import { mapGetters,mapMutations, mapActions,mapState} from 'vuex'
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
        infoData:{},
            refuseVerify:false,
            refuseValue:'',
            verifyRemark:'',
            refuseArr: [
                '开户银行有误',
                '银行卡号有误',
                '授权证明有误',
                '开户支行有误',
                '其他'
            ],
            showDetail:false,
            showPassword:false,
            showDetailArr:[
                {name:'用户姓名',value:'truename'},{name:'注册来源',value:'trace'},{name:'用户类型',value:'type'},
                {name:'上次登录时间',value:'login_time'},{name:'手机号',value:'mobile'},
                {name:'绑定微信',value:'wechat_openid'},{name:'注册时间',value:'reg_time'},{name:'登录次数',value:'num'},{name:'账号主体',value:'title'}
            ],
            currentItem:{},  
    };
  },
  computed: {
     ...mapState(['AdminDataDetail']),
  },
  watch: {},
  created() {},
  mounted() {
    this.Details(this.$route.query.id)
  },
  methods: {
    ...mapActions(['addStoreBankcard','getStoreBankcardDetails','reviewBankcard','getItemDetail','getUserIndexData']),
    /*获取银行卡详情*/
    Details(id){
        this.getStoreBankcardDetails({
        id:id,
        successFun: (e) => {
            this.infoData = e;
            console.log(e);
        }
        });
    },
    //用户详情情页
    async checkDetail(item) {
        if (!this.$GFUN.powerIsInArray([80])) { this._alert('您没有相关权限！',null,'error'); return; }
        await this.getItemDetail({
            type:'userDetail',
            data:{
                uid:item.uid,
                // store_type:item.type
            }
        })
        this.currentItem = {
            ...this.AdminDataDetail,
            wechat_openid:` ${item.wechat_openid!=item.uid ? '已绑定' : '未绑定'}`,
            type:this.$options.filters['formatVar'](item.type,'StoreType'),
            trace:this.$options.filters['formatVar'](this.AdminDataDetail.trace,'traces'),
            login_time:item.login_time > 0 ? this.$options.filters['formatTimestamp'](item.login_time,1) : '从未登录',
            reg_time:this.$options.filters['formatTimestamp'](this.AdminDataDetail.reg_time,1)
        };
        console.log(this.currentItem);
        this.showDetail = true;
    },
    //查看门店详情页
    goStoreDetail(store_type,id) {
            let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:store_type,id,none:1}});
            window.open(routeUrl.href, '_blank');
    },
    //通过认证
    passStore(){
        this._confirm('已向该银行卡打款0.01元？',async () => {
            this.reviewBankcard({id:this.$route.query.id,action_flag:1})
        })
    },
    //拒绝通过
    verifyControl(){
        if (!this.refuseValue) {
            this._alert('请选择拒绝理由',null,'error');
            return;
        }
        if (this.refuseValue === '其他'&& !this.verifyRemark) {
            this._alert('请填写其他理由',null,'error');
            return;
        }
        let data = {
            id:this.$route.query.id,
            action_flag:2,
        }
        data.action_remark = this.refuseValue === '其他' ? this.verifyRemark : this.refuseValue;
        this._confirm('确认操作么？',() => {
            this.reviewBankcard(data)
        })
        
    },
  }
};
</script>

<style lang="scss" scoped>
    .review-bankcard{
        width: 98%;
        margin: 0 auto;
    }
    .blank_space{
        background-color: var(--smtc-color-primary);
        padding: 14px 30px !important;
        text-align:left;
        color: #fff;
        border-radius: 5px;
        display: flex;
        .btn{
            margin-top: 2px;
            margin-left: auto;
            display: flex;
            align-items: center;
        }
        span{
            font-size: 12px;
        }
    }
    .blank_space .icon{
        margin-top: 2px;
        margin-right: 10px;
        i{
            font-size: 26px;
        }
    }

    .store-details{
        margin-top: 20px;
        border-radius: 5px;
        text-align: left;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: space-between;   
        .title{
            background-color: #fff;
            padding: 20px 30px;
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            width: 100%;
            color: #19324e;
            display: flex;
            align-items: center;
            i{
                color: var(--smtc-color-primary);
                margin-right: 10px;
            }
            .btn{
                margin-left: auto;
            }
        }

    }
    .review-info{
        margin-top: 20px;
        background-color: #fff;
        border-radius: 5px;
        text-align: left;
        width: 100%;
        overflow: hidden;
        box-shadow: 0px 0px 10px #e2e7f1;
        .title{
            background-color: #eff4fe;
            padding: 20px 30px;
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            width: 100%;
            color: #19324e;
            display: flex;
            align-items: center;
            i{
                color: var(--smtc-color-primary);
                margin-right: 10px;
            }
        }
    }
    .d-center-between{
        width: 96%;
        margin: 20px auto;
    }
    .bottom{
        display: flex;
        justify-content: center;
        margin:20px 0;
    }
</style>
